import { ENTITY_TAB_BUILDINGS_SCALAR_SCOPE_FILTER_KEYS } from './EntityTabBuildings.constants'

export function getEntityTabBuildingsScopeFilter({ scopeFilterKey, scopeId }) {
  return {
    [scopeFilterKey]: ENTITY_TAB_BUILDINGS_SCALAR_SCOPE_FILTER_KEYS.includes(
      scopeFilterKey
    )
      ? scopeId
      : [scopeId],
  }
}
